import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import CLOUDS from 'vanta/dist/vanta.clouds.min';
import * as THREE from 'three';
import './Recruitment.scss';

const Recruitment: React.FC = () => {
  const { t } = useTranslation();
  const vantaRef = useRef<HTMLDivElement>(null);
  const vantaEffect = useRef<any>(null);

  useEffect(() => {
    if (!vantaRef.current || vantaEffect.current) return;

    try {
      (window as any).THREE = THREE;
      vantaEffect.current = CLOUDS({
        el: vantaRef.current,
        THREE,
        backgroundColor: 0xffffff,
        skyColor: 0x68b8d7,
        cloudColor: 0xf0f0f8,
        cloudShadowColor: 0x7b9cb8,
        sunColor: 0xffcc66,
        sunGlareColor: 0xffdd88,
        sunlightColor: 0xffeeaa,
        speed: 0.5,
      });
    } catch (error) {
      console.error('Vanta initialization error:', error);
    }

    return () => {
      try {
        if (vantaEffect.current) {
          vantaEffect.current.destroy();
          vantaEffect.current = null;
        }
      } catch (error) {
        console.warn('Vanta cleanup error:', error);
      }
    };
  }, []);

  return (
    <div className="recruitment-page">
      <div className="recruitment-bg" ref={vantaRef}></div>
      <div className="recruitment-content">
        <h1>{t('recruitment')}</h1>
        <p>{t('recruitmentIntro')}</p>
        <h2>{t('recruitmentPositionsTitle')}</h2>
        <ul>
          {(t('recruitmentPositions', { returnObjects: true }) as { title: string; requirements: string }[]).map((position, index: number) => (
            <li key={index}>
              <h3>{position.title}</h3>
              <p><strong>{t('recruitmentRequirementsLabel')}</strong> {position.requirements}</p>
            </li>
          ))}
        </ul>
        <p>{t('applyInfo')}</p>
      </div>
    </div>
  );
};

export default Recruitment;